import {Component, Mixins, Prop, Vue} from 'vue-property-decorator';
import { DEFER, DEFERRED, EVENT_CLICK } from './const';
import isAuthorized from '@/mixins/isAuthorized';

@Component
export default class PartCatalogCardDefer extends Mixins(isAuthorized) {
  // Props
  @Prop({ type: Boolean, required: true })
  value: boolean;

  @Prop({ type: String, default: DEFERRED })
  deferredText: string;

  @Prop({ type: String, default: DEFER })
  deferText: string;

  // Computed
  get text() {
    const { deferText, deferredText, value } = this;
    return value ? deferredText : deferText;
  }

  get classes() {
    return { 'part-catalog-card-defer_deferred': this.value };
  }

  // Methods
  onClick() {
    this.$emit(EVENT_CLICK);
  }
}



// WEBPACK FOOTER //
// ./src/components/parts/catalog/card/components/defer/script.ts